export default 
{
  type: "form-number",
  style: "",
  data: {
    label: "New Number Field",
    placeholder: "1234",
    max: 1000000,
    min: 0,
  },
  children: [],
};
